import React, { lazy } from 'react';
import { CheckCircle2Icon } from 'lucide-react';
const outcomes = ['Planificas tus comidas con claridad.', 'Cocinas una sola vez y ganas horas cada día.', 'Comes saludable mientras cuidas tu presupuesto.'];
export function Transformation() {
  return <section className="bg-[#e8f0df] px-5 py-16 sm:px-8 sm:py-24" data-id="element-210" data-mp="rl7m730sf5yp">
      <div className="mx-auto grid max-w-7xl items-center gap-10 lg:grid-cols-2 lg:gap-20" data-id="element-211" data-mp="rmsdmjrt28sc">
        <div className="overflow-hidden rounded-[2rem] border-8 border-[#fffaf0] bg-[#c8d8bb] shadow-xl" data-id="element-212" data-mp="wjsn74nv5to7">
          <img className="h-72 w-full object-cover sm:h-[26rem]" src="https://images.unsplash.com/photo-1547592180-85f173990554?auto=format&fit=crop&w=1200&q=85" alt="Comidas saludables preparadas en recipientes para la semana" width={1200} height={800} loading="lazy" decoding="async" data-id="element-213" data-mp="11hkepxkljdrv" />
        </div>
        <div data-id="element-214" data-mp="1kaegtqx4fbeo">
          <p className="text-sm font-bold uppercase tracking-[0.16em] text-[#397352]" data-id="element-215" data-mp="1k7sd62dcpg1q">
            La solución
          </p>
          <h2 className="font-display mt-4 text-4xl font-black leading-[0.98] tracking-[-0.045em] text-[#143827] sm:text-5xl" data-id="element-216" data-mp="176xcj47gqfxt">
            🌿 Una cocina organizada cambia cómo se siente toda tu semana.
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-[#46604d]" data-id="element-217" data-mp="y6sbdbsv4ds3">
            Por eso creamos Meal Prep Club: un ebook práctico para que tus
            comidas estén listas sin que la cocina ocupe tu vida.
          </p>
          <ul className="mt-7 space-y-4" role="list" data-id="element-218" data-mp="1qw7oq8802ir6">
            {outcomes.map(outcome => <li key={outcome} className="flex items-start gap-3 font-semibold text-[#1b4932]" data-id="element-219" data-mp="1m2wq2udcd8ac">
                <CheckCircle2Icon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-[#a92d3d]" data-id="element-220" data-mp="1h3aaiea1jfyd" />
                {outcome}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}